<div class="info-message">
  <mat-icon>info</mat-icon>
  No hay registros disponibles para mostrar.
</div>
